<script>
  import { clickOutside } from './../utils.js'
  import { cssPrefix } from '../helper-classes.js'

  export let selected = false

  export let label = null
  export let href = '#'
  export let type = 'link'

  // link button or dropdown

  const slots = $$slots
</script>

{#if type === 'dropdown'}
  <!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
  <li
    on:keydown={e => {
      if (e.key === 'Escape') {
        selected = false
      }
    }}
    use:clickOutside
    on:click_outside={() => {
      selected = false
    }}
  >
    <!-- svelte-ignore a11y-missing-attribute -->
    <button
      class={`${cssPrefix}navbar-button has-dropdown`}
      class:is-selected={selected}
      on:click={() => {
        selected = !selected
      }}
    >
      {#if slots && Object.prototype.hasOwnProperty.call(slots, 'label')}
        <slot name="label" />
      {:else}
        {label}
      {/if}
    </button>
    {#if selected}
      <slot />
    {/if}
  </li>
{:else if type === 'button'}
  <li>
    <button class={`${cssPrefix}navbar-item`}>
      <slot />
    </button>
  </li>
{:else if type === 'content'}
  <li>
    <div class={`${cssPrefix}navbar-items`}>
      <slot />
    </div>
  </li>
{:else}
  <li>
    <a on:click {href} class={`${cssPrefix}navbar-button`} class:is-selected={selected}>
      {#if slots && Object.prototype.hasOwnProperty.call(slots, 'label')}
        <slot name="label" />
      {:else}
        {label}
      {/if}
    </a>
  </li>
{/if}
